import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Consumption } from '../Models/Consumption';
import { PHBHPFeaturePackageConsumptionService } from '../ph-bhp-feature-package-consumption.service';
import { ConsumptionPeriod } from '../Models/ConsumptionPeriod';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-quarter-consumption',
  templateUrl: './ph-bhp-quarter-consumption.component.html',
  styleUrls: ['./ph-bhp-quarter-consumption.component.css']
})
export class PhBhpQuarterConsumptionComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isMilliliter = true;
  isLiter = true;
  viewFlag: string = 'liter';
  consumptionJsonData;
  consumptionID: number;
  consumptionData: Array<Consumption> = [];
  consumptionPeriodData: Array<ConsumptionPeriod> = [];
  consumptionQuarterPeriodForm: UntypedFormGroup;
  items: UntypedFormArray;
  periodNumber: number;
  haiOccurrences: number;
  haiEnabled: boolean = false;
  isSaving: boolean = false;
  @Input() userData;
  @Input() formdata;
  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  consumptionConfigDetail: Array<any> = [];
  currentYear: number;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  consumptionYearConfiguration: any;

  constructor(private service: PHBHPFeaturePackageConsumptionService, public appConfig: AppConfig, private router: Router, private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {

    if (this.layoutService.institutionID) {
      this.getConsumptionConfigByInstitutionIdList();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.layoutService.institutionID = Id
      this.getConsumptionConfigByInstitutionIdList();
    });

    this.currentYear = new Date().getFullYear();
    this.periodNumber = 1;
    this.consumptionQuarterPeriodForm = this.fb.group({
      items: this.fb.array([this.createItem()])
    });
    for (let i = 0; i < 3; i++) {
      this.periodNumber = i + 2;
      this.items = this.consumptionQuarterPeriodForm.get('items') as UntypedFormArray;
      this.items.push(this.createItem());
    }
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  createItem(): UntypedFormGroup {
    return this.fb.group({
      consumptionID: this.consumptionID,
      consumptionValue: new UntypedFormControl("", Validators.compose([Validators.required])),
      patientDays: new UntypedFormControl("", Validators.compose([Validators.required])),
      periodNumber: this.periodNumber,
      haiOccurrences: ''
    })
  }

  getConsumptionConfigByInstitutionIdList() {
    this.service.getConsumptionConfigByInstitutionId(this.layoutService.institutionID).subscribe((res) => {
      this.consumptionYearConfiguration = this.service.getConsumptionYearConfiguration(res.consumptionConfigs, this.formdata.year) || {};
      this.consumptionConfigDetail[0] = res;
      this.haiEnabled = this.consumptionConfigDetail[0].enableHAITracking;
    });
  }

  cancelConsupmtionPeriod() {
    this.appConfig.showconsumption = false;
    this.router.navigate(['/consumption/new']);
  }


  amountMeasure() {
    if (this.consumptionYearConfiguration?.amountMeasured === 'u') {
      return this.layoutService.translateText('CONSUMPTION.USED.DISPLAY_TEXT');
    } else if (this.consumptionYearConfiguration?.amountMeasured === 'p') {
      return this.layoutService.translateText('CONSUMPTION.PURCHASED.DISPLAY_TEXT');
    }
  }

  unitMeasure() {
    if (this.consumptionYearConfiguration?.unitOfMeasure === 'l') {
      return this.layoutService.translateText(this.translationKeys.Dashboard.inLiters);
    } else if (this.consumptionYearConfiguration?.unitOfMeasure === 'm') {
      return this.layoutService.translateText('CONSUMPTION.AMOUNT.IN_MILLILITERS');
    }
  }

  saveConsupmtionPeriod(value) {
    this.convertCommaToDot();
    var formValue1: Boolean = false;
    var consumptionValueFlag: Boolean = false;
    var patientDaysFlag: Boolean = false;
    for (let i = 0; i < this.consumptionQuarterPeriodForm.value.items.length; i++) {
      if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue == null) {
        this.consumptionQuarterPeriodForm.value.items[i].consumptionValue = "";
      }
      if (this.consumptionQuarterPeriodForm.value.items[i].patientDays == null || this.consumptionQuarterPeriodForm.value.items[i].patientDays == 0) {
        this.consumptionQuarterPeriodForm.value.items[i].patientDays = "";
      }
      if (!this.haiEnabled || (this.haiEnabled && (this.consumptionQuarterPeriodForm.value.items[i].haiOccurrences == null || this.consumptionQuarterPeriodForm.value.items[i].haiOccurrences == 0))) {
        this.consumptionQuarterPeriodForm.value.items[i].haiOccurrences = "";
      }

      if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue != "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays == "") {
        patientDaysFlag = true;
        break;
      } else if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue == "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays != "") {
        consumptionValueFlag = true;
        break;
      } else if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue != "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays != "") {
        formValue1 = true;
      }
    }

    if (patientDaysFlag) {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PATIENT_DAYS"));
    } else if (consumptionValueFlag) {
      if (this.consumptionYearConfiguration.amountMeasured == "u") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_USED_DATA"));
      } else if (this.consumptionYearConfiguration.unitOfMeasure == "p") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PURCHASED_DATA"));
      }
    } else if (formValue1) {
      this.submitConsumtion()
    } else {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.NO_CHANGES_TO_SAVE"));
    }
  }

  convertCommaToDot() {
    this.consumptionQuarterPeriodForm.value.items.forEach(item => {
      if (typeof item.consumptionValue === 'string') {
        item.consumptionValue = item.consumptionValue.replace(',', '.');
      }
    });
  }

  submitConsumtion() {
    if (this.isSaving) return;
    this.isSaving = true;
    var data = {
      period: this.consumptionYearConfiguration.period.toLowerCase(),
      wardID: this.formdata.wardID.wardID,
      departmentID: this.formdata.departmentID.departmentID,
      departmentTypeID: this.formdata.wardID.departmentTypeID,
      year: this.formdata.year,
      institutionID: this.layoutService.institutionID,
      createdBy: this.userData.userId,
      consumptionPeriodID: null
    }

    this.service.createConsumption(data).subscribe((res: any) => {
      this.consumptionID = res.consumptionID;
      var value = this.consumptionQuarterPeriodForm.value;
      for (let i = 0; i < this.consumptionQuarterPeriodForm.value.items.length; i++) {
        let temp = this.consumptionQuarterPeriodForm.value.items[i].consumptionValue;
        this.consumptionQuarterPeriodForm.value.items[i].consumptionID = this.consumptionID;
        if (this.isMilliliter === false) {
          temp = temp / 1000.0;
          this.consumptionQuarterPeriodForm.value.items[i].consumptionValue = temp;
          this.items.at(i).patchValue({
            consumptionValue: temp
          });
        }
      }


      this.service.createConsumptionPeriod(value.items).subscribe({
        next: res => {
          // this.layoutService.showSuccess(this.layoutService.translateText('CONSUMPTION.CONSUMPTION.SUCCESSFULLY_ADDED_DETAILS'));
        },
        error: err => {

        },
        complete: () => {
          this.router.navigate(['/consumption/past']);
        }
      })
    })
  }

  getControls(frmGrp: UntypedFormGroup, key: string) {
    return (<UntypedFormArray>frmGrp.controls[key]).controls;
  }

  isLiters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'l';
  }

  isMilliliters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'm';
  }
}
